import { Fragment } from 'react';
import { LabelStyled } from 'components/LabelsList.style';
import {
  StyledGroupTitle,
  StyledOperatorWrapper,
  StyledSelectedValueRow,
  StyledSelectedValuesView
} from './SelectedValuesView.style';
import { OperatorContainer } from 'components/LabelsList';
import { Chip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import {
  onClickEditIdx,
  onDeleteSelectedValueByIdx
} from '../useWizardState/wizard.state.actions';

const SelectedValueRow = ({
  selectedValue,
  onDelete,
  onEdit,
  multipleEnabled
}) => {
  const { project, team, areas } = selectedValue;
  return (
    <StyledSelectedValueRow>
      <LabelStyled>
        <StyledGroupTitle>PROJECT</StyledGroupTitle>
        <Chip label={project.name} />

        <StyledGroupTitle>TEAM</StyledGroupTitle>
        <Chip label={team.name} />

        <StyledGroupTitle>AREA/S</StyledGroupTitle>
        {areas.map(area => (
          <Chip key={area.id} label={area.name} />
        ))}

        {multipleEnabled && <Icon name='Pencil' onClick={onEdit} />}
        <Icon name='Close' onClick={onDelete} />
      </LabelStyled>
    </StyledSelectedValueRow>
  );
};

const SelectedValuesView = ({
  selectedValues = [],
  dispatch,
  multipleEnabled
}) => {
  if (selectedValues.length === 0) return null;
  return (
    <StyledSelectedValuesView>
      {selectedValues.map((selectedValue, idx) => (
        <Fragment key={idx}>
          <SelectedValueRow
            selectedValue={selectedValue}
            onDelete={() => dispatch(onDeleteSelectedValueByIdx(idx))}
            onEdit={() => dispatch(onClickEditIdx(idx))}
            multipleEnabled={multipleEnabled}
          />
          {idx < selectedValues.length - 1 && (
            <StyledOperatorWrapper>
              <OperatorContainer operator='OR' />
            </StyledOperatorWrapper>
          )}
        </Fragment>
      ))}
    </StyledSelectedValuesView>
  );
};

export default SelectedValuesView;
